module.exports = __webpack_public_path__ + "img/1eb4044.jpg";